import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';
import jQueryZoom from 'jquery-zoom';

class ImagesOverlayWidget {
	constructor(image, productCode) {
		this._dfd = jQuery.Deferred();

		const initialImageItem = image.clone();

		const contentImgWrapperElm = jQuery('<div class="zoom-content-img-wrapper"></div>');
		contentImgWrapperElm.append(initialImageItem);

		const shouldZoom   = () => !window.matchMedia('(min-width: 700px)').matches;

		const initZoom = () => {
			contentImgWrapperElm.zoom({
				onZoomIn: function() {
					contentImgWrapperElm.addClass('zoom-in');
				},
				onZoomOut: function() {
					contentImgWrapperElm.removeClass('zoom-in');
				}
			});
		};

		const that = this;
		const options = {
			title: productCode,
			content: contentImgWrapperElm,
			responsiveHeightPercent: 75,
			listeners: {
				onClose: () => {
					contentImgWrapperElm.trigger('zoom.destroy');
					that._dfd.resolve();
				}
			}
		}

		$.ep.overlayWidget.mount(options);


		if (shouldZoom()) {
			const imgTag = initialImageItem.find('img')[0] || initialImageItem[0];
			if (imgTag && !imgTag.complete) {
				imgTag.onload = initZoom;
			} else {
				initZoom();
			}
		}
	}

	getPromise() {
		return this._dfd.promise();
	}
}

//Api
const create = function (image, productCode) {
	return new ImagesOverlayWidget(image, productCode);
}

const defaultFunc = function () {

}

//Exports
export {create, defaultFunc as default};
